<template>
    <div class="wrapper">
        <ValidationObserver ref="modalValidation" tag="div" v-slot="{ invalid }">
            <div class="loginBox">
                <div>
                    <img class="logo-img" v-if="logo" :src="logo" />
                    <form @submit.prevent="login()" class="loginBoxInside" name="myform" novalidate="" autocomplete="off">
                    <h1>
                        <span>{{title}}</span>
                    </h1>
                        <div class="form-content">
                            <div class="form-group fadeIn first">
                                <input class="form-control input-underline input-lg input-username" placeholder="User Name" name="userName" type="text" autofocus="" v-model="username" required="required" style="" autocomplete="off">
                                <!-- <h4 class="error" style=""><span>Please enter user name.</span></h4> -->
                            </div>
                            <div class="form-group fadeIn second">
                                <input class="form-control input-underline input-lg input-password" placeholder="Password" name="password" type="password" value="" v-model="password" required="required" autocomplete="off">
                                <!-- <h4 class="error">
                                    <span>Please enter your password.</span>
                                </h4> -->
                            </div>
                            <h4 class="error formerror" v-show="error">{{error}}</h4></div>
                            <button type="submit" class="btn rounded-btn fadeIn third">
                                <span>Log in</span>
                                <i v-if="loading" class="fa fa-refresh fa-spin fa-fw" aria-hidden="true" />
                            </button>
                    </form>
                </div>
            </div>
        </ValidationObserver>
    </div>
</template>
<script>
export default {
	props: ["title", "loading", "error"],
	data: () => ({username: "", password: ""}),
	methods: {
		login() {
			this.$emit("login", {username: this.username, password: this.password});
		}
	},
	computed: {
		logo() {
			return window.whitelabelConfig && window.whitelabelConfig.loginLogo;
		}
	}
};
</script>
<style lang="scss" scoped>
.wrapper {
    display:flex; align-items: center; flex-direction: column; justify-content: center; padding: 20px;
    position: fixed; width: 100vw; height: 100vh; top: 0; left: 0;
    background-color: #203a64;
}

.logo-img {
  max-width: 100%;
}

.loginBox {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  text-align: center;
}

  @media only screen and (max-device-width: 400px) {
    .loginBox {
      width: 100vw;
      padding: 0;
    }
  }
  @media only screen and (min-device-width: 401px) {
    .loginBox {
      width: 600px;
      max-width: 80vw;
      padding: 10%;
    }
  }

.loginBoxInside {
  box-shadow: 0 30px 60px 0 rgba(255, 255, 255, 0.5);
  background-color: white;
  padding: 10%;
  padding-top:2%;
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

/* Simple CSS3 Fade-in Animation */
@-webkit-keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
@-moz-keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
@keyframes fadeIn { from { opacity:0; } to { opacity:1; } }

.fadeIn {
  opacity:0;
  -webkit-animation:fadeIn ease-in 1;
  -moz-animation:fadeIn ease-in 1;
  animation:fadeIn ease-in 1;

  -webkit-animation-fill-mode:forwards;
  -moz-animation-fill-mode:forwards;
  animation-fill-mode:forwards;

  -webkit-animation-duration:1s;
  -moz-animation-duration:1s;
  animation-duration:1s;
}

.fadeIn.first {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.fadeIn.second {
  -webkit-animation-delay: 0.6s;
  -moz-animation-delay: 0.6s;
  animation-delay: 0.6s;
}

.fadeIn.third {
  -webkit-animation-delay: 0.8s;
  -moz-animation-delay: 0.8s;
  animation-delay: 0.8s;
}

.fadeIn.fourth {
  -webkit-animation-delay: 1s;
  -moz-animation-delay: 1s;
  animation-delay: 1s;
}

</style>
